export const toollist =  [
    {
        "Type": "Link",
        "Label": "Fiche info",
        "Color": "primary",
        "Icon": "assignment",
        "Link": ['/','buildings','edit', '$id'],
    },
    {
        "Type": "Button",
        "Label": "Supprimer",
        "Color": "warn",
        "Icon": "delete",
        "Method": "delete"
    },
    {
        "Type": "Link",
        "Label": "Retour",
        "Color": "disabled",
        "Icon": "arrow_back_ios",
        "Link": ['/','buildings'],
    }
];